import clsx from 'clsx';
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import Select from 'react-select';

import QueryParamsNavLink from '@components/QueryParamsNavLink';
import { useAppContext } from '@contexts/AppContext';
import { forum_filter_path, forum_path } from '@routes';
import { TopEntity } from '@utils/backend-api/forumPosts';

import styles from './styles.module.scss';

const COMMENT_FILTER_TAGS = ['jobs', 'finance', 'creator economy', 'metaverse', 'crypto'];

const queryNavLinkClassname = (isActive: boolean) => {
  return clsx(
    styles.forumIndexFilter,
    {
      [styles.forumIndexFilterActive]: isActive,
    },
    styles.mobileMostRecent
  );
};

export default function ForumIndexFilters({ topEntities }: { topEntities: TopEntity[] }) {
  const { isWebview } = useAppContext();
  const location = useLocation();
  const [_searchParams, setSearchParams] = useSearchParams();
  const topEntitiesOptions = topEntities?.map((e) => ({
    label: e.name,
    value: e.name.toLowerCase(),
  }));

  return (
    <div className={styles.forumIndexFilters}>
      <div className="container container-padded">
        <div className={styles.filtersContainer}>
          <div className={styles.leftFilters}>
            <NavLink
              className={clsx(styles.forumIndexFilter, {
                [styles.forumIndexFilterActive]: location.pathname === forum_path(),
              })}
              to={forum_path()}
            >
              Feed
            </NavLink>
            {!isWebview &&
              COMMENT_FILTER_TAGS.map((commentFilterTag) => (
                <QueryParamsNavLink
                  key={commentFilterTag}
                  queryParam="topic"
                  queryParamValue={commentFilterTag}
                  to={forum_filter_path('comments', { topic: commentFilterTag })}
                  className={queryNavLinkClassname}
                >
                  {`#${commentFilterTag}`}
                </QueryParamsNavLink>
              ))}
          </div>

          {!!topEntitiesOptions && topEntitiesOptions.length > 0 && (
            <div className={styles.topEntitiesSelectContainer}>
              <Select
                className={styles.topEntitiesSelect}
                classNamePrefix="select"
                isClearable={true}
                name="entity"
                options={topEntitiesOptions}
                placeholder="Filter by topic"
                onChange={(newValue) =>
                  setSearchParams(newValue?.value ? { topic: newValue.value } : undefined)
                }
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                    primary: '#aaaaaa',
                  },
                })}
                // The `styles` prop extends styling from React Select: https://react-select.com/styles#provided-styles-and-state
                styles={{
                  option: (styles) => ({
                    ...styles,
                    cursor: 'pointer',
                  }),
                  control: (styles) => ({
                    ...styles,
                    cursor: 'pointer',
                  }),
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
